import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getEarnAssetTransactions } from 'services/EarnService'
import { LedgerWalletTransaction } from 'types/ledger/ledgerWalletTransactions'
import { withPaginationPaging } from 'utils/pagination'

export const EARN_ASSET_TRANSACTIONS_PAGE_SIZE = 10

export interface EarnAssetTransactionsDateRange {
  start?: string
  end?: string
}

export const useEarnAssetTransactionsQuery = (
  portfolioId?: string,
  page = 0,
  { start, end }: EarnAssetTransactionsDateRange = {}
) => {
  return useQuery({
    queryKey: reactQueryKeys.earnAssetTransactions(
      portfolioId ?? '',
      page,
      EARN_ASSET_TRANSACTIONS_PAGE_SIZE,
      start,
      end
    ),
    queryFn: () =>
      getEarnAssetTransactions(portfolioId ?? '', {
        page,
        size: EARN_ASSET_TRANSACTIONS_PAGE_SIZE,
        start,
        end,
      }),
    enabled: !!portfolioId,
    select: withPaginationPaging<LedgerWalletTransaction[]>,
  })
}
